import { useState } from "react";
import { ChangeAlertCallbackType, ChangeWidgetsCallbackType } from "../../../Root";
import { useCRMFunction } from './useCRMFunction';
import moment from "moment";
moment.locale("es");

export const useCRMDetail = (changeAlert: ChangeAlertCallbackType, changeWidgets: ChangeWidgetsCallbackType, config) => {
    const { onHandleChangeStatus, handleLeadByUuid, onHandleLeadUpdate, handleLeadData } = useCRMFunction(changeAlert);
    
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [form, setForm] = useState({});
    const [platform, setPlatform] = useState('');
    const [companyGroups, setCompanyGroups] = useState([]);
    const agent = localStorage.session ? JSON.parse(localStorage.session) : {};
    const agentConfig = localStorage.config ? JSON.parse(localStorage.config) : {};

    const saveData = async (result, type, reset?) => {
        setLoading(true);
        setData(JSON.parse(JSON.stringify(result || {})));
        setForm(JSON.parse(JSON.stringify(result || {})));
        setPlatform(JSON.parse(JSON.stringify(type)));
        setLoading(false);
        await onGetCompanyGroup();
    };

    const onGetCompanyGroup = async () => {
        setLoading(true);
        let request = { filters: {all: true} };
        let resp = await handleLeadData(request, 'leadCrmGroupList');
        resp ? setCompanyGroups(resp['content'] || [] ) : setCompanyGroups([]);
        setLoading(false);
    };

    const handleWidgetChange = async (selectedSection, forms?, crmContactFlow?) => {
        const widget = {
            type: 'panelCrmList',
            config: config,
            crmType: platform,
            selectedSection: selectedSection
        }
        if (selectedSection === "contact") {
            crmContactFlow ? 
            widget["crmContactFlow"] = crmContactFlow :
            widget["crmContactFlow"] = (agentConfig["crmInbound"] && "crmInbound") || (agentConfig["crmOutbound"] && "crmOutbound")
        }
        if(forms){
            widget["forms"] = forms;
        }
        return changeWidgets([widget])
    };

    const onUpdateSection = async (section) => {
        setLoading(true);
        const resp = await onHandleChangeStatus(section, null, null, data, agent, form);
        resp ? getLeadByUuid(data['uuid'], section) && setData(JSON.parse(JSON.stringify(form))) : setLoading(false);
    };

    const onUpdateUuid = async (payload) => {
        setLoading(true);
        const resp = await onHandleLeadUpdate(payload);
        resp ? getLeadByUuid(data['uuid'], "company") && setData(JSON.parse(JSON.stringify(form))) : setLoading(false);
    };

    const getLeadByUuid = async (uuid, tab) => {
        let resp = await handleLeadByUuid(uuid, tab);
        if(resp){
            saveData(resp, platform);
        }
        setLoading(false);
    };

    return {
        data,
        loading,
        form,
        companyGroups,
        setData,
        saveData,
        handleWidgetChange,
        onUpdateSection,
        getLeadByUuid,
        onUpdateUuid
    };
};
